export const defaultLinkTemplate = {
  expand: () => ''
};
export const makeBootstrapLinks = someLinks => ({
  appDetails: defaultLinkTemplate,
  appPricingDetails: defaultLinkTemplate,
  mediaFile: defaultLinkTemplate,
  appHostingDetails: defaultLinkTemplate,
  appIcon: defaultLinkTemplate,
  appRating: defaultLinkTemplate,
  partnerDetails: defaultLinkTemplate,
  managePrivateListing: defaultLinkTemplate,
  appManageLink: defaultLinkTemplate,
  appShortLink: defaultLinkTemplate,
  appCreateCommunityQuestionLink: defaultLinkTemplate,
  appVersionHistory: defaultLinkTemplate,
  artifactDownload: defaultLinkTemplate,
  descriptorDownload: defaultLinkTemplate,
  appListing: defaultLinkTemplate,
  appListingCanonical: defaultLinkTemplate,
  trialLicenseActivation: defaultLinkTemplate,
  licensePurchase: defaultLinkTemplate,
  ...someLinks
});